import React, { useMemo, useState } from 'react';

// helpers
import styled from 'styled-components';
import useTranslation from 'hooks/useTranslation';
import { colorsTheme } from 'resources/theme/styled/colors';
import { ContactModel } from 'typings/application/contact';

// components
import Identification from './Tabs/Identification';
import ApplicantInformation from './Tabs/ApplicantInformation';
import { IconSVG, TabModel, Tabs } from '@ui';
import { ReactComponent as CheckIcon } from 'resources/icons/remix-icons/check-line.svg';

type TabKeys = 'applicantInformation' | 'identification';

interface IProps {
  contact: ContactModel;
}

const IndividualWithoutKeyRelationship = ({ contact }: IProps) => {
  const { t } = useTranslation('onboarding');
  const [currentStep, setCurrentStep] = useState<TabKeys>(
    'applicantInformation',
  );

  const tabs = useMemo<TabModel[]>(() => {
    return [
      {
        key: 'applicantInformation',
        label: (
          <>
            {t('applicant_information.general.title')}{' '}
            <StyledIconSVG
              component={CheckIcon}
              color={colorsTheme.colorPrimary}
            />
          </>
        ),
        children: <ApplicantInformation contact={contact} />,
      },

      {
        key: 'identification',
        label: (
          <>
            {t('identification.title')}{' '}
            <StyledIconSVG
              component={CheckIcon}
              color={colorsTheme.colorPrimary}
            />
          </>
        ),
        children: <Identification contact={contact} />,
      },
    ];
  }, [contact]);

  return (
    <Tabs
      useChangeView
      items={tabs}
      activeKey={currentStep}
      defaultActiveKey={currentStep}
      onChange={setCurrentStep}
    />
  );
};

const StyledIconSVG = styled(IconSVG)`
  margin: 0 0 0 ${({ theme }) => theme.marginXXs} !important;
`;

export default IndividualWithoutKeyRelationship;
